import { json } from "react-router-dom";
import { WretchError } from "wretch";

export type ActionWrapper<T> =
    | {
          success: true;
          content: T;
          message: undefined;
      }
    | {
          success: false;
          content: undefined;
          message: string | any;
      };

export const handle_success = (data: any) => {
    return json({ success: true, content: data });
};

const PAYMENT_FAILED_FALLBACK =
    "Le paiement n'a pas abouti. Le prospect peut mettre à jour son moyen de paiement via le lien de paiement ou réessayer plus tard.";

export const handle_error = async (error: WretchError | any) => {
    try {
        if (error?.response) {
            const status = error.response.status;
            if (status === 402) {
                const body =
                    error.json != null && typeof error.json === "object"
                        ? error.json
                        : typeof error.response?.json === "function"
                          ? await error.response.json().catch(() => ({}))
                          : {};
                const message = body?.message && typeof body.message === "string" ? body.message : PAYMENT_FAILED_FALLBACK;
                return json({ success: false, message });
            }
            switch (status) {
                case 400:
                    return json({ success: false, message: error.message });
                case 401:
                    return json({ success: false, message: "Veuillez vous reconnecter." });
                case 403:
                    return json({ success: false, message: "Vous n'avez pas la permission de faire cette action." });
                case 404:
                    return json({ success: false, message: "Cette action n'existe pas, veuillez contacter l'équipe technique." });
                default: {
                    const body =
                        error.json != null && typeof error.json === "object"
                            ? error.json
                            : typeof error.response?.json === "function"
                              ? await error.response.json().catch(() => ({}))
                              : {};
                    const businessDetail = status === 422 && typeof body?.detail === "string" ? body.detail : "";
                    const message =
                        (typeof body?.message === "string" && body.message) ||
                        businessDetail ||
                        `Veuillez contacter l'équipe technique (${error.response.status} ${error.response.statusText}).`;
                    return json({ success: false, message });
                }
            }
        }
    } catch (_error) {
        console.error(_error);
    }
    return json({ success: false, message: "Veuillez contacter l'équipe technique." }, { status: 500 });
};
